export default function checkSessionStorage() {
  // https://blog.greenroots.info/gatsby-the-window-is-not-defined-error-what-and-how-to-fix-it
  // console.log('checkSessionStorage', typeof sessionStorage !== "undefined")

  return typeof sessionStorage !== "undefined"
}
